<template>
  <span>
    <v-container fluid fill-height>
      <v-layout column>
        <v-layout justify-center align-center>
          <v-flex xs12 md9>
            <!-- Start -->
            <v-layout wrap>
              <v-flex xs12 xl6 order-xs2 order-xl1>
                <ProjectDemo />
              </v-flex>
              <v-flex xs12 xl6 order-xs1 order-xl2 class="jumbo">
                <v-layout column justify-center align-center fill-height>
                  <v-flex shrink class="display-3 display-font"
                    >Volition.Page</v-flex
                  >
                  <v-flex shrink class="title font-weight-light text-xs-center">
                    Track your goals and progress any time, any where.
                  </v-flex>
                  <br />
                  <v-flex v-if="user == null" shrink>
                    <v-btn large color="primary" @click="signInAnon">
                      TRY IT WITHOUT SIGN UP
                    </v-btn>
                  </v-flex>
                  <v-flex v-if="user == null" shrink>
                    <v-btn shrink large flat :to="{ name: 'signUp' }">
                      Sign Up
                    </v-btn>
                    <v-btn
                      shrink
                      large
                      flat
                      color="primary"
                      :to="{ name: 'signIn' }"
                      >Sign In</v-btn
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <!-- End -->
          </v-flex>
        </v-layout>

        <v-layout shrink wrap row class="text-xs-center">
          <v-flex class="item" xs12 md4>
            <v-layout align-center justify-center column>
              <v-flex>
                <img
                  src="https://img.icons8.com/wired/64/000000/multiple-devices.png"
                />
              </v-flex>
              <v-flex class="title font-weight-light description-title">
                Any Device</v-flex
              >
              <v-flex class="description">
                Use this web app on any platform. Desktops, iPhones and Android
                phones.
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex class="item" xs12 md4>
            <v-layout align-center justify-center column>
              <v-flex>
                <img
                  src="https://img.icons8.com/wired/64/000000/synchronize.png"
                />
              </v-flex>
              <v-flex class="title font-weight-light description-title">
                Realtime Sync
              </v-flex>
              <v-flex class="description">
                Action taken on any device will immediately show up on other
                devices.
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex class="item" xs12 md4>
            <v-layout align-center justify-center column>
              <v-flex>
                <img
                  src="https://img.icons8.com/wired/64/000000/wifi-off.png"
                />
              </v-flex>
              <v-flex class="title font-weight-light description-title">
                Offline Support
              </v-flex>
              <v-flex class="description">
                In a gym with no internet? It will still work and sync when
                internet connection is restored.
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-footer>
          <v-spacer></v-spacer>
          <v-flex shrink
            >&copy; {{ new Date().getFullYear() }} | Volition.Page</v-flex
          >
          <v-spacer></v-spacer>
        </v-footer>
      </v-layout>
    </v-container>
  </span>
</template>
<script>
import { mapState } from "vuex";
import Auth from "@/classes/Auth";
import ProjectDemo from "./ProjectDemo";
export default {
  computed: {
    ...mapState(["user"])
  },
  components: { ProjectDemo },
  methods: {
    async signInAnon() {
      let auth = new Auth();
      await auth.signInAnonymously();
      this.$router.push({ name: "home" });
    }
  }
};
</script>
<style scoped>
.description-title {
  margin: 20px;
}

.description {
  width: 60%;
}
.item {
  margin-top: 50px;
  margin-bottom: 50px;
}

.jumbo {
  margin-top: 50px;
  margin-bottom: 80px;
}
</style>
